import React, { useState, useEffect, useCallback } from 'react';
import { useFetch } from 'hooks';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Spinner from 'ui/Spinner';
import StatusLabel from '../shared/StatusLabel';
import { useClearNotificationEffect } from '../shared/hooks';

const DigestPreferences = () => {
  const [digestSetting, setDigestSetting] = useState(Boolean);
  const [digestLabel, setLabelSetting] = useState('');
  const { data, loading, error } = useFetch(routes.SETTINGS.MY_ACCOUNT);
  const [isSuccess, setIsSuccess] = useState();

  const clearSetIsSuccess = useCallback(() => {
    setIsSuccess(false);
  }, []);

  useClearNotificationEffect(isSuccess, null, clearSetIsSuccess);

  useEffect(() => {
    if (data?.dailyDigestSettings.receiveDailyDigest) {
      setDigestSetting(data.dailyDigestSettings.receiveDailyDigest);
    }
    if (data?.dailyDigestSettings.label) {
      setLabelSetting(data.dailyDigestSettings.label);
    }
  }, [loading, data, error]);

  const onSettingChange = useCallback(e => {
    const { checked } = e.target;
    request
      .patchJSON(routes.SETTINGS.UPDATE_USER, {
        user: {
          receive_daily_digest: checked.toString(),
        },
      })
      .then(() => {
        setIsSuccess(true);
      })
      .catch((response, statusText, err) => {
        console.error(err, response);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="Wrapper--thin" id="interface-digest-setting">
          <br />
          <div className="d-f ai-fs">
            <h3 className="SettingsContent-heading">
              {t('settings.tab.my_account.activity.title')}
            </h3>

            <StatusLabel
              id="digest-label_status"
              success={isSuccess}
              error={error}
            />
          </div>

          <hr />
          <form>
            <label className="d-f ai-fs" htmlFor="user_receive_daily_digest">
              <input
                id="user_receive_daily_digest"
                type="checkbox"
                data-testid="digest-checkbox"
                onChange={e => {
                  onSettingChange(e);
                }}
                defaultChecked={digestSetting}
              />
              <div className="ml-4">{digestLabel}</div>
            </label>
          </form>
        </div>
      )}
    </>
  );
};

export default DigestPreferences;
